import { Injectable } from '@angular/core';
import { MaterialDemandPositionsDaoService } from '../material-demand-position-dao.service';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import {
  DbPersistenceService,
  Query,
} from 'src/app/_services/persistence/db-persistence/db-persistence.service';
import { AppParameterService } from 'src/app/_services/app-parameter/logic/app-parameter.service';
import { MaterialDemandPositionDbTableDefinition } from './material-demand-position-db-table-definition';
import { MaterialDemandPosition } from 'src/app/_model/material-demand-position';

@Injectable()
export class MaterialDemandPositionsDbDaoService
  implements MaterialDemandPositionsDaoService
{
  constructor(
    private logger: LoggingService,
    private dbPersistenceService: DbPersistenceService,
    private appParameter: AppParameterService,
    private materialDemandPositionTableDefinition: MaterialDemandPositionDbTableDefinition,
  ) {}

  public async saveMaterialDemandPositions(
    materialDemandPositions: MaterialDemandPosition[],
  ): Promise<void> {
    try {
      let db = await this.dbPersistenceService.getImsDb();
      var queries: Query[] = [];
      for (const data of materialDemandPositions) {
        let query: Query = {
          statement:
            'INSERT OR REPLACE INTO ' +
            this.materialDemandPositionTableDefinition.tableName +
            '(id, label, databag, materialdemandid, materialdemandlabel, materialdescription, posstatus, comment, amount, materialdeliveryid, materialdeliverylabel, materialid, materiallabel, drawingparttnbr, dlvinfopalletnbr, dlvinfoloadingorder, dlvinfocomment)' + // 2
            ' VALUES (?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?,?)',
          parameters: [
            Number(data.getImsId()),
            data.label,
            data.databag ? JSON.stringify(data.databag) : undefined,
            data.materialDemand
              ? Number(data.materialDemand.getImsId())
              : undefined,
            data.materialDemand ? data.materialDemand.label : undefined,
            data.materialDescription,
            data.posStatus,
            data.comment,
            data.amount,
            data.materialDelivery
              ? Number(data.materialDelivery.getImsId())
              : undefined,
            data.materialDelivery ? data.materialDelivery.label : undefined,
            data.material ? Number(data.material.getImsId()) : undefined,
            data.material ? data.material.label : undefined,
            data.drawingPartNumber,
            data.deliveryInfoPalletNumber,
            data.deliveryInfoLoadingOrder,
            data.deliveryInfoComment,
          ],
        };
        queries.push(query);
      }
      await this.dbPersistenceService.executeBatch(db, queries);
    } catch (error) {
      this.logger.log(
        'Error saving',
        this.materialDemandPositionTableDefinition.tableName,
        'to db',
        error,
        '-',
        error?.message,
      );
    }
  }

  public async getMaterialDemandPositions(): Promise<MaterialDemandPosition[]> {
    try {
      let db = await this.dbPersistenceService.getImsDb();
      let objects: MaterialDemandPosition[] = [];

      let data = await this.dbPersistenceService.executeQuery(db, {
        statement:
          'SELECT * FROM ' +
          this.materialDemandPositionTableDefinition.tableName +
          ';',
        parameters: null,
      });
      for (let i = 0; i < data.values.length; i++) {
        let row = data.values[i];
        objects.push(
          MaterialDemandPosition.fromDto(
            {
              id: row['id'],
              label: row['label'],
              materialdemand: {
                id: row['materialdemandid'],
                label: row['materialdemandlabel'],
              },
              materialdescription: row['materialdescription'],
              posstatus: row['posstatus'],
              comment: row['comment'],
              amount: row['amount'],
              materialdelivery: {
                id: row['materialdeliveryid'],
                label: row['materialdeliverylabel'],
              },
              material: {
                id: row['materialid'],
                label: row['materiallabel'],
              },
              secondaryid: undefined,
              drawingparttnbr: row['drawingparttnbr'],
              dlvinfopalletnbr: row['dlvinfopalletnbr'],
              dlvinfoloadingorder: row['dlvinfoloadingorder'],
              dlvinfocomment: row['dlvinfocomment'],
            },
            row['databag'] ? JSON.parse(row['databag']) : undefined,
            this.appParameter.getFormatLabelForObject(
              'ims/MaterialDemandPosition',
            ),
          ),
        );
      }
      return objects;
    } catch (error) {
      this.logger.log(
        'Error reading',
        this.materialDemandPositionTableDefinition.tableName,
        'from db',
        error,
      );
    }
    return [];
  }

  public async reset() {}

  public async clear() {
    let db = await this.dbPersistenceService.getImsDb();
    this.logger.log(
      this.constructor.name,
      'truncate table',
      this.materialDemandPositionTableDefinition.tableName,
    );
    await this.dbPersistenceService.truncateTable(
      db,
      this.materialDemandPositionTableDefinition.tableName,
    );
  }
}
